//@ts-nocheck
import { useForm } from 'react-hook-form';
import { Skill } from '@/types';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { SimpleForm } from '@/components/SimpleForm';
import { FormInput } from '@/components/shared/FormInput';
import { FormTextarea } from '@/components/shared/FormTextArea';

export const SkillDetails = ({ skill }: { skill: Skill }) => {
  const methods = useForm({
    defaultValues: {
      name: skill?.name || '',
      description: skill?.description || '',
    },
  });

  const {
    reset,
    formState: { isDirty },
  } = methods;

  const onSubmit = (formData) => {
    // console.log('Form Data Submitted:', formData);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>{skill.name}</CardTitle>
      </CardHeader>
      <CardContent>
        <SimpleForm
          methods={methods}
          onSubmit={onSubmit}
          submitText="Save Changes"
          className="space-y-6"
        >
          <FormInput name="name" label="Skill Name" type="text" disabled />
          <FormTextarea
            name="description"
            label="Description"
            rows={5}
            disabled
          />
        </SimpleForm>
      </CardContent>
    </Card>
  );
};
